import { render, staticRenderFns } from "./CapitalOneSetEmail.vue?vue&type=template&id=e97d8ff8&scoped=true&"
import script from "./CapitalOneSetEmail.vue?vue&type=script&lang=js&"
export * from "./CapitalOneSetEmail.vue?vue&type=script&lang=js&"
import style0 from "./CapitalOneSetEmail.vue?vue&type=style&index=0&id=e97d8ff8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e97d8ff8",
  null
  
)

export default component.exports